<div class="flex flex-col content-holder">
  <div class="back-holder flex items-center">
    <div
      class="w-fit cursor-pointer flex items-center"
      (click)="goToBack()"
      *ngIf="!initialStep || (initialStep && currentStep.index !== initialStep)"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 15L7.5 10L12.5 5"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      {{ "common-keywords.back" | translate }}
    </div>
  </div>
  <form (ngSubmit)="goToNext()" class="flex flex-col gap-24x">
    <ng-container *ngIf="currentStep.step === 'name'">
      <div class="content-title">
        {{ "common-keywords.company-name" | translate }}
      </div>
      <ui-input
        [placeholder]="'common-keywords.type-here' | translate"
        class="content-control"
        type="email"
        size="large"
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="company.orgName"
        (ngModelChange)="authFlowSvc.setCompanyDetail(company)"
      ></ui-input>
    </ng-container>
    <ng-container *ngIf="currentStep.step === 'size'">
      <div class="content-title">
        {{ "common-keywords.company-size" | translate }}
      </div>
      <div class="flex flex-wrap size-tag-holder">
        <div
          class="size-tag flex items-center justify-center"
          [class.active]="company.numOfEmp === item.val"
          *ngFor="let item of sizeList"
          (click)="
            company.numOfEmp = item.val; authFlowSvc.setCompanyDetail(company)
          "
        >
          {{ item.title }}
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="currentStep.step === 'industry'">
      <div class="content-title">
        {{ "common-keywords.industry" | translate }}
      </div>
      <ui-select
        [placeholder]="'common-keywords.type-here' | translate"
        class="content-control"
        size="large"
        [dataList]="industryList"
        optionLabel="label"
        optionValue="label"
        [virtualScrollItemSize]="49"
        [showSearch]="true"
        [inlineSearch]="true"
        [searchPlaceholder]="'common-keywords.search' | translate"
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="company.industry"
        (ngModelChange)="authFlowSvc.setCompanyDetail(company)"
        wrapperClass="register-industry-select-wrapper"
      ></ui-select>
    </ng-container>
    <ng-container *ngIf="currentStep.step === 'fn'">
      <div class="content-title">
        {{ "common-keywords.first-name" | translate }}
      </div>
      <ui-input
        [placeholder]="'common-keywords.type-here' | translate"
        class="content-control"
        type="email"
        size="large"
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="company.firstName"
        (ngModelChange)="authFlowSvc.setCompanyDetail(company)"
      ></ui-input>
    </ng-container>
    <ng-container *ngIf="currentStep.step === 'ln'">
      <div class="content-title">
        {{ "common-keywords.last-name" | translate }}
      </div>
      <ui-input
        [placeholder]="'common-keywords.type-here' | translate"
        class="content-control"
        type="email"
        size="large"
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="company.lastName"
        (ngModelChange)="authFlowSvc.setCompanyDetail(company)"
      ></ui-input>
    </ng-container>
    <ng-container *ngIf="currentStep.step === 'country'">
      <div class="content-title">
        {{ "common-keywords.your-country" | translate }}
      </div>
      <ui-select
        [placeholder]="'common-keywords.type-here' | translate"
        class="content-control"
        size="large"
        [dataList]="countryList"
        optionLabel="name"
        optionValue="code3"
        [itemTemplate]="itemTemplate"
        [virtualScrollItemSize]="49"
        [showSearch]="true"
        [inlineSearch]="true"
        [searchPlaceholder]="'common-keywords.search' | translate"
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="company.country"
        (ngModelChange)="authFlowSvc.setCompanyDetail(company)"
        wrapperClass="register-country-select-wrapper"
      ></ui-select>
      <ng-template #itemTemplate let-item="item">
        <div class="country-select-item">
          <img [src]="item.image" [alt]="item.name" /> {{ item.name }}
        </div>
      </ng-template>
    </ng-container>
    <ng-container *ngIf="currentStep.step === 'phoneNumber'">
      <div class="content-title">
        {{ "common-keywords.contact-number" | translate }}
      </div>
      <ui-mobile-number
        #mobileNumberComponent
        class="content-control"
        size="large"
        [virtualScrollItemSize]="49"
        wrapperClass="register-mobile-number-country-select-wrapper"
        [placeholder]="'common-keywords.type-here' | translate"
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="company.phoneNumber"
        (ngModelChange)="
          phoneValidationError = mobileNumberComponent.validationError;
          authFlowSvc.setCompanyDetail(company);
          selectedCountry = mobileNumberComponent.selectedCountry.dialCode || ''
        "
      ></ui-mobile-number>
      <div
        class="text-sm text-red-600 -mt-2"
        *ngIf="company.phoneNumber && mobileNumberComponent.validationError"
      >
        This phone number is invalid or incorrectly formatted.
      </div>
    </ng-container>
    <ui-button
      (btnClick)="goToNext()"
      [isDisabled]="
        isDisable ||
        loading ||
        (currentStep.step === 'phoneNumber' && phoneValidationError)
      "
      [loading]="loading"
      class="content-button"
      size="large"
      type="black"
    >
      {{ "common-keywords.next" | translate }}
      <!--      <span>-->
      <!--        <svg-->
      <!--          width="10"-->
      <!--          height="10"-->
      <!--          viewBox="0 0 10 10"-->
      <!--          fill="none"-->
      <!--          xmlns="http://www.w3.org/2000/svg"-->
      <!--        >-->
      <!--          <path-->
      <!--            d="M9.6875 0.833333C9.6875 0.545685 9.45431 0.3125 9.16667 0.3125C8.87902 0.3125 8.64583 0.545685 8.64583 0.833333V1.5625C8.64583 2.44618 8.64543 3.07761 8.60499 3.57258C8.56504 4.06147 8.48865 4.37119 8.362 4.61977C8.11233 5.10977 7.71394 5.50816 7.22393 5.75783C6.97536 5.88449 6.66564 5.96088 6.17675 6.00082C5.68178 6.04126 5.05034 6.04167 4.16667 6.04167H2.09074L3.80578 4.32662C4.00918 4.12322 4.00918 3.79345 3.80578 3.59005C3.60239 3.38665 3.27261 3.38665 3.06922 3.59005L0.465049 6.19422C0.26165 6.39761 0.26165 6.72739 0.465049 6.93078L3.06922 9.53495C3.27261 9.73835 3.60239 9.73835 3.80578 9.53495C4.00918 9.33155 4.00918 9.00178 3.80578 8.79838L2.09074 7.08333H4.18978C5.04528 7.08334 5.71922 7.08334 6.26157 7.03903C6.81488 6.99382 7.27694 6.89991 7.69684 6.68596C8.38285 6.33642 8.94059 5.77868 9.29013 5.09267C9.50408 4.67278 9.59799 4.21072 9.64319 3.65741C9.68751 3.11506 9.6875 2.44113 9.6875 1.58564V0.833333Z"-->
      <!--          />-->
      <!--        </svg>-->
      <!--      </span>-->
    </ui-button>
  </form>
</div>
